var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.originalEvent
    ? _c("app-sale-history-event-sent-info", {
        attrs: { event: _vm.originalEvent, sale: _vm.sale },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }